import styled from '@emotion/styled/macro'

import { LinearProgress as MuiProgress } from '@mui/material'

const _Progress = styled(MuiProgress)`
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
  width: 100%;
  z-index: 2
`

const LinearProgress = ({ isVisible, ...rest }) => (
  <_Progress style={{ visibility: isVisible ? 'visible' : 'hidden' }} {...rest} />
)

export { LinearProgress }
